import React, { useEffect } from 'react'
import { appConfig } from 'config'
import { BrowserRouter, Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './Store'
import { ThemeProvider } from 'styled-components'
import defaultTheme from 'Components/common/Theme'
import App from 'App'
import { Dashboard, PageNotFound } from 'Pages'
const MyThemeProvider: any = ThemeProvider
// const MyRouter: any = Router
const MyProvider: any = Provider
import 'assets/styles/antd-customized.css'
import 'assets/styles/App.css'
import { ConfigProvider } from 'antd'

type Props = {}

// const MainApp: React.FunctionComponent<Props> = () => {
//   const currentVersion = 1
//   const autoClearCache = appConfig.version !== currentVersion
//   if (autoClearCache) {
//     console.log('autoClearCache')
//   }

//   const MyApp = () => {
//     return (
//       <BrowserRouter>
//         <Routes>
//           <Route path="/" element={<Dashboard />} />
//           <Route path="*" element={<PageNotFound />} />
//         </Routes>
//       </BrowserRouter>
//     )
//   }

//   return (
//     <MyThemeProvider theme={defaultTheme}>
//       <MyProvider store={store}>
//         {/* <ClearBrowserCacheBoundary auto={autoClearCache} fallback="Loading" duration={60000}>
//             <App />
//           </ClearBrowserCacheBoundary> */}
//         <App />
//       </MyProvider>
//     </MyThemeProvider>
//   )
// }

// export default MainApp

function MainApp() {
  return (
    <MyThemeProvider theme={defaultTheme}>
      <ConfigProvider>
        <MyProvider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </MyProvider>
      </ConfigProvider>
    </MyThemeProvider>
  )
}

export default MainApp
